module.exports = __webpack_public_path__ + "img/yemen.254e44a8.png";